import React, { Component } from 'react'
import Select from 'react-select'
import { FiUser } from 'react-icons/fi'
import { IoMdArrowDropdown } from 'react-icons/io'
import { keyBy } from 'lodash'
import { TrackJS } from 'trackjs'
import {
  WrRoot,
  Footer,
  Button,
  Router,
  context,
  withContext,
  Dropdown,
  Link,
  Modal,
  productUtils,
  updateContextState,
  extendLocale,
  connectRequest,
  ErrorText,
} from '@tools/wr-catalog-base'
import CartPopup from './@components/CartPopup'
import './App.css'
import en from './en'
import { initStore } from '@store'
import { UserTrigger, DropdownContainer, PTCCatalog } from './styles'
import { isPartnerExperience } from '@utils/isPartnerExperience'

initStore()
extendLocale(en)
window.wrContext = context

const MenuList = ({ username, logout, isLoggedIn }) => (
  <div>
    {isLoggedIn && (
      <>
        <CartPopup />
        {!isPartnerExperience() && (
          <>
            <Link secondary to="/proposals">
              My Proposals
            </Link>
            <DropdownContainer>
              <Dropdown>
                {({ DropdownTrigger, DropdownList }) => (
                  <>
                    <DropdownTrigger>
                      <UserTrigger>
                        <FiUser className="user-icon" size={20} />
                        {username}
                        <IoMdArrowDropdown className="arrow-icon" size={20} />
                      </UserTrigger>
                    </DropdownTrigger>
                    <DropdownList>
                      <ul>
                        <li onClick={logout}>
                          <Button fullWidth primary={false}>
                            Log out
                          </Button>
                        </li>
                      </ul>
                    </DropdownList>
                  </>
                )}
              </Dropdown>
            </DropdownContainer>
          </>
        )}
      </>
    )}
    {!isLoggedIn && (
      <Link secondary to="/login">
        Log in
      </Link>
    )}
  </div>
)

/** @extends {Component<{ context: import('@tools/wr-catalog-base').WrContextType }>} */
class App extends Component {
  constructor(props) {
    super(props)

    this.state = {
      menuOpened: false,
    }

    TrackJS.install({
      token:
        process && process.env && process.env.REACT_APP_WR_TRACKJS_TOKEN
          ? process.env.REACT_APP_WR_TRACKJS_TOKEN
          : 'e7442525f69e441eb1a8441efdce14fd',
      application: 'ptc',
    })
  }

  getTotalPrice = () => {
    const { cart } = this.props.context.state
    let totalPrice = 0
    const withoutDividing = true

    cart.forEach((product) => {
      totalPrice += productUtils.getPrice(product, withoutDividing)
    })

    return totalPrice
  }

  redirectToLogin = () => {
    this.props.context.history.push(this.props.context.getRoutePath('login'))
  }

  handleCatalogChange = (selectedOption) => {
    if (selectedOption) {
      window.localStorage.setItem('savedCatalog', selectedOption.value)
      updateContextState((state) => {
        const oldId = state.selectedCatalogId
        const newId = selectedOption.value
        state.selectedCatalogId = newId
        state.priceFilter = {
          minValue: 0,
          maxValue: 0,
          values: [0, 0],
        }
        state.savedCategories[oldId] = state.categories
        state.categories = state.savedCategories[newId] || []
      })
    }
  }

  render() {
    const { menuOpened } = this.state
    const { user } = this.props.context.state
    const { history } = this.props.context
    const { userInfoFetch } = this.props

    const email =
      this.props.context.state.isLoggedIn &&
      (isPartnerExperience() ? userInfoFetch.value?.Email : user.email?.substring(0, user.email.lastIndexOf('@')))
    const username = this.props.context.state.isLoggedIn && user ? email : ''
    const logout = this.props.context.actions.logout
    const price = this.getTotalPrice()
    const isLoggedIn = this.props.context.state.isLoggedIn
    const {
      context: {
        state: { selectedCatalogId, allCatalogsById = {} },
        constants: {
          client: { catalogIds },
          isSsoDisabled,
        },
        theme,
      },
    } = this.props

    const isLoginPage = history.location.pathname.includes('/login')
    const isTokenRedirectPage = history.location.pathname.includes('/redirect/')

    if (!isLoggedIn && !isLoginPage && !isTokenRedirectPage && !isPartnerExperience()) {
      this.redirectToLogin()
      return null
    }

    const isPtcUser = !!user?.email && /^.*@ptc.com$/.test(user?.email)

    const isInRestrictedRoute = !isTokenRedirectPage && !isLoginPage

    if (!isSsoDisabled && !isPtcUser && isInRestrictedRoute) {
      return (
        <div style={{ display: 'flex', justifyContent: 'center', margin: '2rem 0' }}>
          <ErrorText>You do not have access to the PTC Service Catalog</ErrorText>
        </div>
      )
    }

    const catalogs = catalogIds.map((id) => allCatalogsById[id]).filter(Boolean)
    const options = catalogs.map((cat) => ({
      value: cat.id,
      label: cat.name,
      public: cat.is_public,
    }))
    const selectedOption = options.find((opt) => opt.value === selectedCatalogId)

    return (
      <PTCCatalog className="ptc-catalog">
        <nav>
          <div>
            <Button
              style={{ background: '#0099b3', color: 'white' }}
              as="a"
              href="mailto:service-offer-management@ptc.com"
            >
              Ask a Question
            </Button>
            {options.length > 1 && (
              <div className="loginBox">
                <Select
                  className="select"
                  value={selectedOption}
                  onChange={this.handleCatalogChange}
                  options={options}
                />
              </div>
            )}
          </div>
          <Link to={context.getRoutePath('index')} className="absolutely-centered">
            <img src={theme.brand.logo} alt="brand logo" />
          </Link>
          <MenuList username={username} logout={logout} price={price} isLoggedIn={isLoggedIn} />
        </nav>
        {menuOpened && (
          <div className="mobile-menu-list">
            <div className="container">
              <MenuList username={username} logout={logout} price={price} />
            </div>
          </div>
        )}
        <Router />
        <Footer />
        <Modal />
      </PTCCatalog>
    )
  }
}

const ConnectedApp = withContext(
  connectRequest(() => {
    const { constants } = context
    const {
      host,
      client: { companyId, partnerCatalogId },
    } = constants

    return {
      allCatalogsFetch: {
        url: `${host}/beta/companies/${companyId}/cataloginfos`,
        comparison: false,
        then: ({ data }) => {
          updateContextState((state) => {
            state.allCatalogsById = keyBy(data, 'id')
          })

          return { value: data }
        },
      },
      partnerCatalogItemsInfo: partnerCatalogId
        ? {
            url: `${host}/api/v1/service-catalogs/products/search`,
            method: 'POST',
            body: JSON.stringify({ data: { catalogId: partnerCatalogId } }),
            comparison: false,
            then: ({ data }) => {
              updateContextState((state) => {
                state.partnerCatalogItemsInfo = data
              })

              return { value: data }
            },
          }
        : { value: null },
      userInfoFetch: {
        comparison: false,
        ...(isPartnerExperience()
          ? {
              value: () => {
                const sfConn = context.constants.getSfConn()
                return sfConn.sobject('User').findOne({ Id: context.state.user.externalId }).select('Name, Email')
              },
              then: ({ Name, Email }) => {
                const user = {
                  ...context.state.user,
                  email: Email,
                  username: Name,
                }
                updateContextState((state) => {
                  state.user = user
                })

                return { value: user }
              },
            }
          : { value: null }),
      },
    }
  })(App),
)

const AppRoot = () => {
  return (
    <WrRoot>
      <ConnectedApp />
    </WrRoot>
  )
}

export default AppRoot
